import React, { useState, useEffect } from "react";
import WidgetList from "./WidgetList";
import WidgetEmptyState from "./WidgetEmptyState";
import KonfhubContainer from "../../../revampComponents/Atom/Container";
import LoadingSpinner from "../../../revampComponents/Atom/Loading";
import customToast from "../../../components/common/basic/Toast";
import { getWidgets } from "../../../revampCRUD/widget.crud";

const WidgetManager = (props) => {
  const [widgetList, setWidgetList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWidgets = async () => {
      try {
        const res = await getWidgets();
        setWidgetList(res?.data || []);
      } catch (err) {
        customToast.error(err?.response?.data?.error || 'Something went wrong');
        setWidgetList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWidgets();
  }, []);

  return (
    <KonfhubContainer>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {widgetList?.length === 0 ? (
            <WidgetEmptyState {...props} />
          ) : (
            <WidgetList
              props={props}
              widgetList={widgetList}
              setWidgetList={setWidgetList}
            />
          )}
        </>
      )}
    </KonfhubContainer>
  );
};

export default WidgetManager;
